<template>
  <div class="z-display-inlineBlock z-relative" :class="{'focus':isFocus}">
  <input v-if="type === 'text'" type="text" :class="{'read-only':readonly === true}" class="zj-input-reset zj-long-input z-font-size-12" v-model="inputData" :readonly="readonly" :style="{background: currColor,width: inpWidth}">
  <input ref="searchInput"  v-if="type === 'select'" type="text" :placeholder="placeholder" :readonly="readonly" class="input select-input z-color-666" style="font-size: 1.5rem;" @focus="isFocus = true;$emit('focus')" @blur="isFocus = false;$emit('blur')" v-model="inputData">
  </div>
</template>
<script>
  export default {
    data() {
      return {
      isFocus:false,
      inputData:'',
      inputStyle:{
        white:"#fff",
        hui:'#ddd',
        width360:'360px',
        width268:'268px'
      },
      currColor:'#ddd',
      inpWidth:'360px'
    }
    },
    props: {
      value: {
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String,
        default: ''
      },
      bccolor: {
        type: String,
        default: 'white'
      },
      inpwidth: {
        type: String,
        default: 'width360'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      focu: {
        type: Boolean,
        default: false
      }
    },
    created() {
      this.inputData = this.value
    },
    watch: {
      value() { this.inputData = this.value },
      inputData() { this.$emit('input', this.inputData)},
    },
    mounted(){
      this.currColor = this.inputStyle[this.bccolor]
      this.inpWidth = this.inputStyle[this.inpwidth]
    },
  }
</script>
<style scoped>
  .zj-input-reset {
    display: inline-block;
    height: 30px;
    padding-top: 0;
    padding-left: 10px;
    padding-bottom: 0;
    border: 1px solid #ccc;
    line-height: inherit;
    outline: none;
    color: #666;
    font-size: 14px;
  }
  input.read-only:hover{cursor:not-allowed;}
  .select-input { width:calc(100% - 3rem); padding: 0.1rem 2.2rem 0rem .8rem;}
</style>



// WEBPACK FOOTER //
// src/components/commons/XfromInput.vue